import { useFetchFollowings } from '@/hooks/useFetchFollowings'
import { toFollowingList } from '@/lib/link'
import { SecondaryPageLink } from '@/PageManager'
import { unwrappedFollowListAtom } from '@/atoms/lists'
import { currentPubkeyAtom } from '@/atoms/session'
import { HugeiconsIcon } from '@hugeicons/react'
import { Loading03Icon } from '@hugeicons/core-free-icons'
import { useAtomValue } from 'jotai'
import { useTranslation } from 'react-i18next'

export default function Followings({ pubkey }: { pubkey: string }) {
  const { t } = useTranslation()
  const accountPubkey = useAtomValue(currentPubkeyAtom)
  const followList = useAtomValue(unwrappedFollowListAtom)
  const { followings, isFetching } = useFetchFollowings(pubkey)

  return (
    <SecondaryPageLink
      to={toFollowingList(pubkey)}
      className="flex gap-1 hover:underline w-fit items-center text-xs"
    >
      {accountPubkey === pubkey ? (
        (followList?.length ?? 0)
      ) : isFetching ? (
        <HugeiconsIcon icon={Loading03Icon} className="animate-spin size-4" />
      ) : (
        followings.length
      )}
      <div className="text-muted-foreground">{t('Following')}</div>
    </SecondaryPageLink>
  )
}
